import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { AdminPageLayout } from "@/features/admin/components/AdminPageLayout";
import { LearningPathSetupFlow } from "@/features/admin/learning-path-setup/LearningPathSetupFlow";
import {
  isLearningPathSetupStepId,
  type LearningPathSetupStepId,
} from "@/features/admin/learning-path-setup/learningPathSetupSteps";

type LearningPathSearchParams = {
  step?: LearningPathSetupStepId;
};

export const Route = createFileRoute("/admin/learning-paths/$pathId")({
  component: LearningPathPage,
  validateSearch: (search: Record<string, unknown>): LearningPathSearchParams => ({
    step: isLearningPathSetupStepId(search.step) ? search.step : undefined,
  }),
  remountDeps: ({ params }) => params.pathId,
});

/** A saved path's admin page: its setup steps, read-only without Courses.Manage. */
function LearningPathPage() {
  const { pathId } = Route.useParams();
  const { step } = Route.useSearch();

  return (
    // ProtectedRoute lets in anyone with the permission OR the role, so the role is one that has
    // Courses.Read: an Admin without it is turned away.
    <ProtectedRoute requiredPermissions={["Courses.Read"]} requiredRoles={["SuperAdmin"]}>
      <AdminPageLayout>
        <LearningPathSetupFlow pathId={pathId} step={step} />
      </AdminPageLayout>
    </ProtectedRoute>
  );
}
